import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { WhatWeOffer } from '../components/sections/WhatWeOffer';
import { HowItWorks } from '../components/sections/HowItWorks';
export function Offerings() {
  return <>
      <PageHeader eyebrow="What We Offer" title="Digital resources for learning, creating and entertainment" description="Every product we publish is a digital file or online resource delivered electronically after purchase. No physical goods are sold or shipped." data-id="element-220" data-mp="2uqpurk0wdaih" />
      <WhatWeOffer data-id="element-221" data-mp="38qhem1e3hl4e" />
      <HowItWorks data-id="element-222" data-mp="38pza6hha40le" />
    </>;
}